import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2904fb6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = { class: "error-content" }
const _hoisted_3 = { class: "d-flex align-items-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-2 fs-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle-fill" })
], -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status",
  style: {"width":"3rem","height":"3rem"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", {
                innerHTML: this.error
              }, null, 8, _hoisted_5)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.spin && !this.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["spinner", this.spinnerClass + this.modeClasses])
        }, _hoisted_7, 2))
      : _createCommentVNode("", true)
  ], 64))
}